import { render, staticRenderFns } from "./Step3.vue?vue&type=template&id=2b735686&scoped=true&"
import script from "./Step3.vue?vue&type=script&lang=ts&"
export * from "./Step3.vue?vue&type=script&lang=ts&"
import style0 from "./Step3.vue?vue&type=style&index=0&id=2b735686&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b735686",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b735686')) {
      api.createRecord('2b735686', component.options)
    } else {
      api.reload('2b735686', component.options)
    }
    module.hot.accept("./Step3.vue?vue&type=template&id=2b735686&scoped=true&", function () {
      api.rerender('2b735686', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wizard/Step3.vue"
export default component.exports